module.exports = __webpack_public_path__ + "img/alberto.4b9ea51e.jpg";